import styled from "@emotion/styled";

function SkillBar({ name, value }) {
  let AnotherComp = styled.div`
    width: ${(props) => props.width}%;
  `;

  return (
    <>
      <li className="skills-item">
        <AnotherComp className="wrapper" width={value}>
          <h3 className="skills-title">{name}</h3>
          <data className="skills-data" value="10">
            {value}%
          </data>
        </AnotherComp>
        <div className="skills-progress-box">
          <AnotherComp className="skills-progress" width={value}></AnotherComp>
        </div>
      </li>
    </>
  );
}
export default SkillBar;
